import { SimpleList } from "@/components/list";

export const OFFERINGS_CONSTANTS = {
  title: "OneMind’s Compliance Management — How We Help You",
  list: [
    {
      title: "Continuous Vulnerability Scanning",
      subTitle: "Catch security gaps before attackers do",
      content: (
        <SimpleList
          points={[
            "AI-powered scanning detects unpatched software, misconfigurations, and outdated controls.",
            "Real-time exploit intel from Tenable enhances detection.",
            "Full visibility across cloud, IoT, servers, and on-prem.",
          ]}
        />
      ),
    },
    {
      title: "Automated, Zero-Downtime Patching",
      subTitle: "Fix fast. Stay uninterrupted.",
      content: (
        <SimpleList
          points={[
            "Deploy patches automatically across Windows, Linux & 3rd-party apps.",
            "Integrates with Red Hat and VMware for seamless updates.",
            "Built-in rollback ensures uptime even during patch failures.",
          ]}
        />
      ),
    },
    {
      title: "AI-Powered Risk Prioritization",
      subTitle: "Focus on what matters most",
      content: (
        <SimpleList
          points={[
            "Rank vulnerabilities by severity, exploitability & business risk",
            "Predicts which CVEs are likely to be weaponized",
            "Reduces alert fatigue and accelerates time-to-patch",
          ]}
        />
      ),
    },
    {
      title: "MITRE ATT&CK & Compliance Alignment",
      subTitle: "See threats clearly, stay audit-ready",
      content: (
        <SimpleList
          points={[
            "Maps findings to MITRE ATT&CK® for better response strategy",
            "Supports PCI-DSS, SOC 2, and NIST alignment",
            "Enables red/blue team exercises and compliance reporting",
          ]}
        />
      ),
    },
  ],
};
